export default "__VITE_ASSET__Nc70J48W__"